var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack303({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.35,9.69l1.47-.17a1.37,1.37,0,0,0,.37.85,1,1,0,0,0,.74.3,1,1,0,0,0,.79-.36,1.39,1.39,0,0,0,.32-1,1.26,1.26,0,0,0-.31-.9A1,1,0,0,0,8,8.12a2.86,2.86,0,0,0-.7.11L7.46,7a1.34,1.34,0,0,0,.93-.26A.94.94,0,0,0,8.72,6a.86.86,0,0,0-.24-.64.89.89,0,0,0-.63-.23.9.9,0,0,0-.66.27,1.25,1.25,0,0,0-.33.78L5.47,5.93A3.16,3.16,0,0,1,5.9,4.79a2,2,0,0,1,.82-.67A2.8,2.8,0,0,1,7.9,3.88a2.31,2.31,0,0,1,1.78.71,1.82,1.82,0,0,1,.55,1.31A1.85,1.85,0,0,1,9.1,7.55a1.83,1.83,0,0,1,1.08.65,1.89,1.89,0,0,1,.41,1.22,2.4,2.4,0,0,1-.76,1.77,2.64,2.64,0,0,1-1.89.73,2.6,2.6,0,0,1-1.77-.62A2.42,2.42,0,0,1,5.35,9.69Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8,
    cy: 8,
    r: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack303);
export default __webpack_public_path__ + "static/media/Symbolpack_3_03.a10bb647f21248dbb928e22cd4ee41d5.svg";
export { ForwardRef as ReactComponent };